// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export var EPartnerRewardsSource = /*#__PURE__*/function (EPartnerRewardsSource) {
  EPartnerRewardsSource["E2e"] = "e2e";
  EPartnerRewardsSource["Newbuilding"] = "newbuilding";
  return EPartnerRewardsSource;
}({});
export var ESubject = /*#__PURE__*/function (ESubject) {
  ESubject["Advertising"] = "advertising";
  ESubject["Another_question"] = "another_question";
  ESubject["Changed_phone"] = "changed_phone";
  ESubject["Commercial"] = "commercial";
  ESubject["Complaint"] = "complaint";
  ESubject["Complaint_from_owner_photo"] = "complaint_from_owner_photo";
  ESubject["Complaint_from_owner_property"] = "complaint_from_owner_property";
  ESubject["Documents"] = "documents";
  ESubject["Kp_change"] = "kp_change";
  ESubject["Kp_creation"] = "kp_creation";
  ESubject["Login"] = "login";
  ESubject["Login_another_question"] = "login_another_question";
  ESubject["Moderation"] = "moderation";
  ESubject["Money"] = "money";
  ESubject["Offers"] = "offers";
  ESubject["Partner_rewards"] = "partner_rewards";
  ESubject["Pr_media"] = "pr_media";
  ESubject["Xml_unloading"] = "xml_unloading";
  ESubject["Constructor_project"] = "constructor_project";
  return ESubject;
}({});